import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import { allStepsEDL } from '@screens/edl/utils'

import Button from '@components/button/Button'
import Steps from '@components/steps/Steps'

import useI18n from '@i18n/useI18n'

const StepsSection = () => {
  const i18n = useI18n()

  const [stepSelected, setStepSelected] = React.useState(1)

  const steps = React.useMemo(() => allStepsEDL(stepSelected, i18n), [stepSelected])

  return (
    <Section>
      <SectionTitle>Steps</SectionTitle>
      <Row>
        <Button label="Etape 1" onClick={() => setStepSelected(1)} status="active" />
        <Button label="Etape 2" onClick={() => setStepSelected(2)} status="active" />
        <Button label="Etape 3" onClick={() => setStepSelected(3)} status="active" />
      </Row>
      <Steps steps={steps} labelColor="black" />
    </Section>
  )
}

export default StepsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Row = styled(View)<{ dark?: boolean }>`
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 32px;
`
